import React from "react";
import styled from "styled-components";

type AlertStatus = "error" | "warning" | "success" | "info";
type AlertVariant = "solid" | "ghost";

type AlertProps = {
  status: AlertStatus;
  variant?: AlertVariant;
  children: React.ReactNode;
};

const Alert = (props: AlertProps) => {
  const { children, status, variant = "solid" } = props;

  return (
    <AlertContainer variant={variant} status={status}>
      {children}
    </AlertContainer>
  );
};

type AlertContainerProps = {
  status: AlertStatus;
  variant: AlertVariant;
};

const AlertContainer = styled.div<AlertContainerProps>`
  color: ${({ theme, variant }) => {
    switch (variant) {
      case "solid":
        return theme.colors.white;
      case "ghost":
        return theme.colors.text;
    }
  }};
  background-color: ${({ theme, status, variant }) => {
    if (variant === "solid") {
      switch (status) {
        case "error":
          return theme.colors.error;
        case "success":
          return theme.colors.success;
        case "info":
          return theme.colors.info;
        case "warning":
          return theme.colors.warning;
      }
    } else if (variant === "ghost") {
      switch (status) {
        case "error":
          return theme.colors.errorLight;
        case "success":
          return theme.colors.successLight;
        case "info":
          return theme.colors.infoLight;
        case "warning":
          return theme.colors.warningLight;
      }
    }
  }};
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 3px;
  font-weight: ${({ variant }) => (variant === "ghost" ? "500" : "700")};
  border-left-style: solid;
  border-left-width: ${({ variant }) => variant === "ghost" && "3px"};
  border-left-color: ${({ theme, status }) => {
    switch (status) {
      case "error":
        return theme.colors.error;
      case "success":
        return theme.colors.success;
      case "info":
        return theme.colors.info;
      case "warning":
        return theme.colors.warning;
    }
  }};
`;

export default Alert;
